import { Directive, OnDestroy, OnInit, Self } from '@angular/core';
import { AngularMultiSelect } from 'angular2-multiselect-dropdown';
import { Subscription } from 'rxjs/Subscription';

/**
 * Works around angular2-multiselect-dropdown 3.0.0 search bugs:
 * - closing the dropdown clears the search text but leaves grouped options filtered out;
 * - the grouped cache is only built on init, so searching after `data` changes uses stale options.
 * Every time the dropdown opens or closes, the search is cleared, and the grouped cache is rebuilt
 * from the current data only when `data` or `groupBy` changed since the last rebuild.
 */
@Directive({
  selector: 'angular2-multiselect[multiselectResetSearch]'
})
export class MultiselectResetSearchDirective implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  private cachedData: Array<any>;
  private cachedGroupBy: string;

  constructor(@Self() private multiselect: AngularMultiSelect) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.multiselect.onOpen.subscribe(() => this.resetSearch()),
      this.multiselect.onClose.subscribe(() => this.resetSearch())
    );
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length) {
      this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
    }
  }

  private resetSearch(): void {
    const groupBy: string = this.multiselect.settings && (this.multiselect.settings.groupBy as string);
    if (groupBy && this.isGroupCacheStale(groupBy)) {
      this.cachedData = this.multiselect.data;
      this.cachedGroupBy = groupBy;
      this.multiselect.groupCachedItems = this.multiselect.transformData(this.multiselect.data || [], groupBy);
    }
    this.multiselect.clearSearch();
  }

  private isGroupCacheStale(groupBy: string): boolean {
    return this.multiselect.data !== this.cachedData || groupBy !== this.cachedGroupBy;
  }
}



// WEBPACK FOOTER //
// ./src/app/directives/multiselect-reset-search/multiselect-reset-search.directive.ts